import React from "react";
import { dealer } from "../WhereToBuy/Interfaces/Interface";
import ContactInfoScreen from "./ContactInfoScreen";

interface ContactsProps {
    navigation: any;
    route: any;
}

const Contacts: React.FC<ContactsProps> = ({ navigation }) => {
    const ourContacts: dealer = {
        coordinates: [59.962724, 30.267494],
        name: "Deante",
        address: "197198, г. Санкт-Петербург, ул. Ждановская д. 45, пом. 219Н",
        workTime: ["Пн-Пт 10:00 - 20:00", "Сб-Вс c 11:00 - 19:00"],
        phoneNumbers: ["+7 909 014-65-35"],
        webSites: ["https://deante.pro"],
        mails: ["a.koltovskii@deante.pro"],
        brand_manager: "Колтовский Александр",
    };

    return (
        <>
            {/* SEO Helmet закомментирован, если нужно — раскомментируй */}
            {/* <Helmet prioritizeSeoTags>
                <title>Контакты | Deante</title>
                <meta property="og:title" content="Контакты | Deante" />
                <meta
                    name="description"
                    content="Контакты бренда Deante, телефон для связи - +7 909 014-65-35, почта: a.koltovskii@deante.pro"
                />
                <meta
                    property="og:description"
                    content="Контакты бренда Deante, телефон для связи - +7 909 014-65-35, почта: a.koltovskii@deante.pro"
                />
                <meta property="og:url" content="https://deante.pro/contacts" />
                <meta name="twitter:title" content="Контакты Deante" />
                <meta
                    name="twitter:description"
                    content="Свяжитесь с Deante: телефоны, почта, адреса. Мы на связи."
                />
                <meta name="twitter:image" content="https://deante.pro/js/logo/contacts-preview.jpg" />
            </Helmet> */}

            <ContactInfoScreen
                navigation={navigation}
                title="Контакты Deante"
                contact={ourContacts}
                showBrandManager={true}
            />
        </>
    );
};

export default React.memo(Contacts);
